import React from "react";
import {
    Container,
    Paper,
    Typography,
    Box,
    makeStyles,
    Divider,
} from "@material-ui/core";
import Logo from "../../../assets/images/logo-footer.png";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4, 0),
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
    },
    paper: {
        padding: theme.spacing(4),
    },
    title: {
        marginBottom: theme.spacing(2),
        fontWeight: "bold",
    },
    section: {
        marginBottom: theme.spacing(3),
    },
    footer: {
        marginTop: theme.spacing(4),
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    logo: {
        marginTop: theme.spacing(1),
        height: 40,
    },
}));

const PrivacyPolicy = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Container maxWidth="md">
                <Paper className={classes.paper}>
                    <Box mb={4}>
                        <Typography variant="h4" component="h1" gutterBottom className={classes.title}>
                            PRIVACY POLICY
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            Last updated: December 07, 2025
                        </Typography>

                        <Box mt={4} className={classes.section}>
                            <Typography variant="h6" gutterBottom>1. Introduction</Typography>
                            <Typography variant="body1" paragraph>
                                Reeco Science and Technology Co., Ltd ("Company", "We", "Us", or "Our") operates the VnEmisoft Vĩnh Long application (the "Service"). This Privacy Policy explains how we handle your information. Our core principles are strictly limiting data collection, ensuring your anonymity, and never sharing your data with third parties.
                            </Typography>
                        </Box>

                        <Box className={classes.section}>
                            <Typography variant="h6" gutterBottom>2. Information We Collect</Typography>
                            <Typography variant="body1" paragraph>
                                We only collect information that you voluntarily provide to us. None of the information we collect is required to use the basic functions of the Service, and we do not link this information to your identity for the purpose of tracking or profiling.
                            </Typography>

                            <Box mt={2} mb={1}>
                                <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>A. Personal Data (Email Address)</Typography>
                            </Box>
                            <Typography variant="body1" paragraph>
                                We may ask for your Email Address. Providing this is entirely optional.
                                <br />
                                We collect your email address solely for the following specific purposes:
                            </Typography>
                            <ul>
                                <li>
                                    <Typography variant="body1">To confirm your registered email.</Typography>
                                </li>
                                <li>
                                    <Typography variant="body1">To send you system alerts or notifications relevant to the Service.</Typography>
                                </li>
                            </ul>
                            <Typography variant="body1" paragraph>
                                We do not use your email address for marketing campaigns, and we do not use it to track your identity across other services.
                            </Typography>

                            <Box mt={2} mb={1}>
                                <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>B. Usage Data & Device Permissions</Typography>
                            </Box>
                            <Typography variant="body1" paragraph>
                                <strong>Usage Data:</strong> We may collect anonymous diagnostic data (such as app crashes or performance issues) to help us improve the app. This data does not identify you personally.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>Device Permissions:</strong> In order to provide specific features, the Application may request access to your device's Location, Camera, or Photo Library. You can grant or deny these permissions at any time in your device settings.
                            </Typography>
                        </Box>

                        <Box className={classes.section}>
                            <Typography variant="h6" gutterBottom>3. How We Use Your Information</Typography>
                            <Typography variant="body1" paragraph>
                                We use the collected data strictly for:
                            </Typography>
                            <ul>
                                <li><Typography variant="body1">Providing and maintaining the Service.</Typography></li>
                                <li><Typography variant="body1">Sending you necessary alerts and confirmations via email (as described above).</Typography></li>
                                <li><Typography variant="body1">Diagnosing technical issues to improve app stability.</Typography></li>
                            </ul>
                        </Box>

                        <Box className={classes.section}>
                            <Typography variant="h6" gutterBottom>4. No Tracking Policy</Typography>
                            <Typography variant="body1" paragraph>
                                We respect your privacy. We do not use cookies or similar technologies to track your activity across other websites or applications. We do not build user profiles for advertising purposes.
                            </Typography>
                        </Box>

                        <Box className={classes.section}>
                            <Typography variant="h6" gutterBottom>5. Disclosure of Data (No Third-Party Sharing)</Typography>
                            <Typography variant="body1" paragraph>
                                We do not sell, trade, or otherwise transfer your Personal Data to outside parties.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                We do not share your data with advertisers.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                We do not share your data with analytics companies for the purpose of tracking you.
                            </Typography>
                            <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginTop: '16px' }}>Exception for Legal Requirements:</Typography>
                            <Typography variant="body1" paragraph>
                                We may disclose your Personal Data only if required to do so by law or in response to valid requests by public authorities (e.g., a court or a government agency).
                            </Typography>
                        </Box>

                        <Box className={classes.section}>
                            <Typography variant="h6" gutterBottom>6. Data Security</Typography>
                            <Typography variant="body1" paragraph>
                                We strive to use commercially reasonable means to protect your Personal Data. However, please be aware that no method of transmission over the Internet or method of electronic storage is 100% secure.
                            </Typography>
                        </Box>

                        <Box className={classes.section}>
                            <Typography variant="h6" gutterBottom>7. Children's Privacy</Typography>
                            <Typography variant="body1" paragraph>
                                Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13.
                            </Typography>
                        </Box>

                        <Box className={classes.section}>
                            <Typography variant="h6" gutterBottom>8. Changes to this Privacy Policy</Typography>
                            <Typography variant="body1" paragraph>
                                We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
                            </Typography>
                        </Box>

                        <Box className={classes.section}>
                            <Typography variant="h6" gutterBottom>9. Contact Us</Typography>
                            <Typography variant="body1" paragraph>
                                If you have any questions about this Privacy Policy, You can contact us:
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>Company Name:</strong> Reeco Science and Technology Co., Ltd
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>Address:</strong>39/2/4-39/2/4a Street No. 3, Thu Duc Ward, Ho Chi Minh City, Vietnam
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>Email:</strong> info@reecotech.com.vn
                            </Typography>
                            <Typography variant="body1" paragraph>
                                <strong>Website:</strong> <a href="https://reecotech.com.vn/" target="_blank" rel="noopener noreferrer">https://reecotech.com.vn/</a>
                            </Typography>
                        </Box>
                    </Box>

                    <Divider />

                    <Box className={classes.footer}>
                        <Typography variant="subtitle2" color="textSecondary">
                            Power by
                        </Typography>
                        <img src={Logo} alt="ReecoTech Logo" className={classes.logo} />
                    </Box>
                </Paper>
            </Container>
        </div>
    );
};

export default PrivacyPolicy;
